/* eslint-disable @next/next/no-img-element */
import DownloadFileStyles from '../../styles/elements/DownloadFilesStyles.module.scss';
import Link from 'next/link';

const DownloadFile = ({icon, title, copy, button, link}) => {
  return (
    <div className={DownloadFileStyles.holder}>
      <div className={DownloadFileStyles.filedownload}>
        <div className={DownloadFileStyles.icon}>
          <img src={icon} alt="Download Icon" />
        </div>
        <div className={DownloadFileStyles.details}>
          <h2>{title}</h2>
          <p>{copy}</p>
          <Link href={link}>
            <button className={DownloadFileStyles.button}>{button}</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DownloadFile;
